












// Importing card component
import BaseCard from '@/ui/BaseCard.vue';

export default {
    name: 'BaseCardIcon',
    components: {
        'base-card': BaseCard,
    },
    props: {
        icon: '',
        text: '',
    },
    data() {
        return {};
    },
    methods: {},
};
